import "./UiButton.css";
import { CSSProperties } from "react";

import { IBaseButtonProps } from "../../models/IBaseButtonProps";
import { getButtonStyle, getVariantVars, UiButtonVariant } from "./baseButtonCode";

type UiButtonSize = "default" | "compact";

interface IUiButtonProps extends IBaseButtonProps {
    variant: UiButtonVariant;
    size?: UiButtonSize;
}

const UiButton: React.FC<IUiButtonProps> = (btnProps) => {
    const {
        variant,
        disabled,
        name,
        size,
        text,
        title,
        width,
        iconSrc,
        iconAlt,
        onClickCallback: clickCallback,
    } = btnProps;

    const baseStyle = getButtonStyle(disabled, width, 0.5) as CSSProperties;
    const variantStyle = getVariantVars(variant);
    const className = (size === "compact") ? "ui-btn ui-btn--compact" : "ui-btn";

    return (
        <button
            className={className}
            onClick={disabled ? undefined : clickCallback}
            disabled={disabled}
            name={name ? name : ""}
            title={title}
            style={{ ...baseStyle, ...variantStyle }}
            type="button"
        >
            {iconSrc ? (
                <img
                    className="ui-btn__icon"
                    src={iconSrc}
                    alt={iconAlt ? iconAlt : ""}
                    aria-hidden={iconAlt ? undefined : true}
                />
            ) : null}

            <span className="ui-btn__text">{text}</span>
        </button>
    );
};

export default UiButton;
